import { render } from "./HelloWorld.vue?vue&type=template&id=068c4437&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=068c4437&scoped=true&lang=css"

import exportComponent from "E:\\demo\\test-in-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068c4437"]])

export default __exports__